import { Account } from './account';
import { Bridge } from './bridge/bridge';
import { Dashboard } from './dashboard';
import { EnplugDashboardSDK } from './sdk';
import { Social } from './social';
/**
 * This file is an entry point to the Enplug Dashboard SDK,
 * a piece of software required for Enplug Dashboard apps to communicate with Enplug.
 */

declare global {
  interface Window {
    enplug: EnplugDashboardSDK;
  }
}

function createDashboardSDK(): EnplugDashboardSDK {
  const bridge = new Bridge(window);
  const sdk: EnplugDashboardSDK = {
    account: new Account(bridge),
    dashboard: new Dashboard(bridge),
    social: new Social(bridge),
  };
  window.enplug = sdk;
  return sdk;
}

export default createDashboardSDK();
